module.exports = __webpack_public_path__ + "img/bl-back.d5951ad5.png";